module.exports = __webpack_public_path__ + "static/media/2-2.2b1fe0db.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/slides/2-2.png
// module id = 639
// module chunks = 0